export default __webpack_public_path__ + "pinnacle-studio.de97a031.png";